import React, { useEffect, useState } from "react";
import CreateUserFormView from "./CreateUserFormView/CreateUserFormView";
import { User, UserGender, UserPatch, UserRole, UserStatus } from "../../types/user.types";
import { Organization } from "../../../organization/types/organization.types";
import { useAuth } from "../../../auth/hooks";
import { useSingleUser } from "../../hooks/useAdminUser";
import inputValidityChecker from "../../../../utils/inputValidityChecker";
import { extractAxoisErrorsMessage } from "../../../errorHandler/utils/errors.utils";


export interface UserFormData {
  email?: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  role?: UserRole;
  organization?: Organization;
  numberPhone?: string;
  gender?: UserGender;
  status?: UserStatus;
}

export interface UserErrorState {
  isErrorEmail?: boolean;
  isErrorPassword?: boolean;
  isErrorFirstName?: boolean;
  isErrorLastName?: boolean;
  isErrorRole?: boolean;
  isErrorOrganization?: boolean;
  isErrorNumberPhone?: boolean;
  isErrorGender?: boolean;
  isErrorStatus?: boolean;
  allGood?: boolean;
  message?: string;
}

const checkValidityUser = (user: UserPatch): UserErrorState => {
  const errorMessages: string[] = [];
  const initErrorState: UserErrorState = {
    isErrorEmail: false,
    isErrorPassword: false,
    isErrorFirstName: false,
    isErrorLastName: false,
    isErrorRole: false,
    isErrorOrganization: false,
    isErrorNumberPhone: false,
    isErrorGender: false,
    isErrorStatus: false,
    allGood: true,
  };

  if (!inputValidityChecker.validateEmail(user.user_email)) {
    errorMessages.push("Email invalide");
    initErrorState.isErrorEmail = true;
    initErrorState.allGood = false;
  }

  if (!inputValidityChecker.validateNotEmptyText(user.user_firstname)) {
    errorMessages.push("Prénom invalide");
    initErrorState.isErrorFirstName = true;
    initErrorState.allGood = false;
  }

  if (!inputValidityChecker.validateNotEmptyText(user.user_lastname)) {
    errorMessages.push("Nom invalide");
    initErrorState.isErrorLastName = true;
    initErrorState.allGood = false;
  }



  if (!inputValidityChecker.validateNotEmptyText(user.user_phone_number)) {
    errorMessages.push("Numéro de téléphone invalide");
    initErrorState.isErrorNumberPhone = true;
    initErrorState.allGood = false;
  }

  return { ...initErrorState, message: errorMessages.join(", ") };


}
export default function CreateUserForm({
  isUpdate,
  userId,
  onSuceess
}: {
  isUpdate?: boolean;
  userId?: string;
  onSuceess?: (user: User) => void;
}) {
  const [formData, setFormData] = useState<UserFormData>({});
  const [errorStatus, setErrorStatus] = useState<UserErrorState>({});
  const { userRole } = useAuth();
  const { singleUserQuery, patchUser } = useSingleUser(userId);
  
  const setFormDataValue = (key: keyof UserFormData, value: string) => {
    setFormData({ ...formData, [key]: value });
  };


  useEffect(() => {
    if (isUpdate && singleUserQuery.data) {
      setFormData({
        email: singleUserQuery?.data?.user_email,
        firstName: singleUserQuery?.data?.user_firstname,
        lastName: singleUserQuery?.data?.user_lastname,
   
        numberPhone: singleUserQuery?.data?.user_phone_number,
        gender: singleUserQuery?.data?.user_gender,
       
      });

    }
  }, [singleUserQuery.data, isUpdate, singleUserQuery.isLoading, userId]); // eslint-disable-line

  const convertFormData = (formData: UserFormData) => {
    return {
      user_email: formData.email,
      user_firstname: formData.firstName,
      user_lastname: formData.lastName,
      user_role: formData.role,
      organization_id: formData.organization?.organization_id,
      user_phone_number: formData.numberPhone,
      user_gender: formData.gender,
      user_status: formData.status,
  }
  }


  const handleSubmit = () => {

    const userData = convertFormData(formData);
    const errorState = checkValidityUser(userData);

    if (errorState.allGood) {

      if(isUpdate){
      patchUser.mutate({data: userData, callback: ({result, error}) => {
        if (error) {
          const errorMessage = extractAxoisErrorsMessage(error);
          setErrorStatus({message: errorMessage});
          return;
        }

        if (result) {
          if (result) {
            setFormData({});
            if (onSuceess) {
              onSuceess(result);
            }
          }
        }

      }});
    
 
  }   
}else{
  
    setErrorStatus(errorState);
  }

  }




  if (isUpdate && singleUserQuery.isLoading) {
    return <div>Chargement...</div>;
  }
  return (
    <CreateUserFormView
      setFormData={setFormDataValue}
      formData={formData}
      submitLabel={isUpdate ? "Modifier" : "Créer"}
      currentUserRoleCreator={userRole}


      errorStatus={errorStatus}
      messageError={errorStatus.message}
      handleSubmit={handleSubmit}
      isLoading={patchUser.isLoading}
    />
  );
}
